import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { error: Error | null }

const RELOAD_KEY = 'agntx_chunk_reload'

function isChunkError(error: Error): boolean {
  const msg = error.message
  return msg.includes('dynamically imported module') ||
    msg.includes('Failed to fetch') ||
    msg.includes('Loading chunk') ||
    msg.includes('Loading CSS chunk') ||
    msg.includes('MIME type')
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary] caught:', error.message)
    console.error('[ErrorBoundary] component stack:\n' + info.componentStack)

    if (isChunkError(error)) {
      const lastReload = sessionStorage.getItem(RELOAD_KEY)
      const now = Date.now()
      if (!lastReload || now - Number(lastReload) > 10_000) {
        sessionStorage.setItem(RELOAD_KEY, String(now))
        window.location.reload()
        return
      }
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', fontSize: 14, maxWidth: 420, margin: '80px auto', textAlign: 'center' }}>
          <p style={{ fontSize: 18, fontWeight: 600 }}>Something went wrong</p>
          <p style={{ color: '#888', marginTop: 8 }}>
            A new version may have been deployed. Reloading should fix it.
          </p>
          <button
            style={{ marginTop: 16, padding: '8px 20px', cursor: 'pointer', borderRadius: 8, border: '1px solid #ddd', background: '#111', color: '#fff', fontWeight: 600, fontSize: 14 }}
            onClick={() => window.location.reload()}
          >
            Reload Page
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
